<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";
import { mapState } from "vuex";
import QRCode from "qrcode";

export default {
  components: { Layout },
  computed: {
    ...mapState({ account: (s) => s.account }),
    baseUrl() {
      return (process.env.VUE_APP_URL_PAINEL || "").replace(/\/$/, "");
    },
    inviteLink() {
      const uuid = this.account?.user?.apn_invitation_uuid;
      return uuid ? `${this.baseUrl}/apn/cadastro/${uuid}` : "";
    },
  },
  data() {
    return {
      loading: false,
      list: [],
      total: 0,

      inviteModal: false,
      showQrModal: false,
      qrDataUrl:   "",
      copied:      false,

      fields: [
        { key: "name",          label: "Nome" },
        { key: "telefone",      label: "Telefone" },
        { key: "email",         label: "E-mail" },
        { key: "numero_grupo",  label: "Nº Grupo" },
        { key: "created_at",    label: "Data" },
      ],
    };
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      this.loading = true;
      api.get("apn/formulario").then((r) => {
        if (r.data.status === "success") {
          this.list  = r.data.list;
          this.total = r.data.total;
        }
      }).finally(() => { this.loading = false; });
    },

    openInvite() {
      this.inviteModal = true;
    },

    copyLink() {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(this.inviteLink).then(() => {
          this.copied = true;
          setTimeout(() => { this.copied = false; }, 2500);
        });
      } else {
        const el = document.createElement("textarea");
        el.value = this.inviteLink;
        document.body.appendChild(el);
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);
        this.copied = true;
        setTimeout(() => { this.copied = false; }, 2500);
      }
    },

    shareWhatsApp() {
      const msg = `Olá! Você foi selecionado(a) para o nosso Grupo VIP da APN. Acesse o link para garantir sua vaga: ${this.inviteLink}`;
      window.open("https://wa.me/?text=" + encodeURIComponent(msg), "_blank");
    },

    async openQrCode() {
      this.qrDataUrl = await QRCode.toDataURL(this.inviteLink, {
        width: 280, margin: 2, color: { dark: "#27416e", light: "#ffffff" },
      });
      this.showQrModal = true;
    },

    downloadQr() {
      const a    = document.createElement("a");
      a.href     = this.qrDataUrl;
      a.download = "convite-apn-qrcode.png";
      a.click();
    },
  },
};
</script>

<template>
  <Layout>
    <div class="page-title-box d-flex align-items-center justify-content-between mb-4">
      <div>
        <h3 class="mb-0">Convite APN</h3>
        <p class="text-muted mb-0 mt-1">Gerencie os convidados para o Grupo VIP da APN.</p>
      </div>
      <b-button variant="success" @click="openInvite">
        <i class="mdi mdi-whatsapp mr-1"></i> Convidar
      </b-button>
    </div>

    <div class="card">
      <div class="card-body">
        <div v-if="loading" class="text-center py-4">
          <b-spinner variant="primary"></b-spinner>
        </div>
        <b-table stacked="md"
          v-else
          :items="list"
          :fields="fields"
          responsive
          show-empty
          empty-text="Nenhum convidado cadastrado ainda."
          class="table-hover"
        >
        </b-table>
      </div>
    </div>

    <!-- Invite Modal -->
    <b-modal v-model="inviteModal" title="Convidar para APN" hide-footer centered>
      <p class="text-muted small mb-3">
        Compartilhe o link abaixo para que a pessoa preencha o formulário e entre no Grupo VIP.
      </p>

      <b-input-group class="mb-4">
        <b-form-input :value="inviteLink" readonly style="font-size:12px;"></b-form-input>
        <b-input-group-append>
          <b-button variant="outline-secondary" @click="copyLink" :title="copied ? 'Copiado!' : 'Copiar link'">
            <i :class="copied ? 'mdi mdi-check text-success' : 'mdi mdi-content-copy'"></i>
          </b-button>
        </b-input-group-append>
      </b-input-group>

      <b-button
        block
        class="mb-2"
        variant="outline-secondary"
        @click="copyLink"
      >
        <i class="mdi mdi-content-copy mr-1"></i>
        {{ copied ? "Link Copiado!" : "Copiar Link" }}
      </b-button>

      <b-button block class="mb-2" variant="outline-primary" @click="openQrCode">
        <i class="mdi mdi-qrcode mr-1"></i> Gerar QR Code
      </b-button>

      <b-button block variant="success" @click="shareWhatsApp">
        <i class="mdi mdi-whatsapp mr-1"></i> Enviar no WhatsApp
      </b-button>
    </b-modal>

    <!-- QR Code Modal -->
    <b-modal v-model="showQrModal" title="QR Code — Convite APN" hide-footer centered>
      <div class="text-center py-2">
        <img :src="qrDataUrl" alt="QR Code" style="max-width:280px;border-radius:8px;" />
        <p class="text-muted small mt-3 mb-3">
          Aponte a câmera do celular para o QR Code para acessar o formulário de convite.
        </p>
        <b-button variant="outline-primary" @click="downloadQr">
          <i class="mdi mdi-download mr-1"></i> Baixar imagem
        </b-button>
      </div>
    </b-modal>
  </Layout>
</template>
